import { gql } from "@apollo/client";
import VendorFields from "~/lib/queries/fragments/VendorFields";

export default gql`
  mutation TransferOwnership($vendorId: ObjectId!, $newOwnerId: ObjectId!) {
    transferOwnership(vendorId: $vendorId, newOwnerId: $newOwnerId) {
      _id
      ...VendorFields
    }
  }

  ${VendorFields}
`;
